interface EmptyStateProps {
  emoji?: string;
  title: string;
  body?: string;
  action?: React.ReactNode;
}

export function EmptyState({ emoji, title, body, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-border-subtle bg-card px-6 py-10 text-center">
      {emoji && <div className="mb-3 text-4xl" aria-hidden>{emoji}</div>}
      <h3 className="text-base font-medium text-text-primary">{title}</h3>
      {body && <p className="mt-1 max-w-xs text-sm text-text-muted">{body}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
